"use client";

import { useEffect } from "react";
import { sendEvent } from "@/features/analytics/gtm/event";
import type { GTMCartItemType } from "@/features/analytics/types/event.type";
import { DIETS_PER_PAGE } from "@/features/diets/const";
import { dietsPresets } from "@/features/diets/data/presets";

type ViewItemListHandlerProps = {
  items: Pick<
    GTMCartItemType,
    "item_id" | "item_name" | "item_brand" | "price"
  >[];
  page?: number;
  dietType?: string;
  mealsCount?: string | number;
  kcal?: string | number;
  searchTerm?: string;
  priceFrom?: string | number;
  priceTo?: string | number;
  sort?: string;
};

export const ViewItemListHandler = ({
  items,
  page = 1,
  dietType,
  mealsCount,
  kcal,
  searchTerm,
  priceFrom,
  priceTo,
  sort,
}: ViewItemListHandlerProps) => {
  const numberOfMeals =
    mealsCount && mealsCount in dietsPresets
      ? dietsPresets[mealsCount as keyof typeof dietsPresets]
      : mealsCount;

  useEffect(() => {
    if (items.length === 0) {
      return;
    }

    const offset = (page > 0 ? page - 1 : 0) * DIETS_PER_PAGE;

    const eventItems = items.map((item, indexOnPage) => ({
      ...item,
      index: offset + indexOnPage + 1,
    }));

    const payload = {
      event: "view_item_list" as const,
      diet_type: dietType,
      meals_count: numberOfMeals,
      kcal,
      search_term: searchTerm,
      price_from: priceFrom,
      price_to: priceTo,
      sort,
      ecommerce: {
        item_list_name: window.location.pathname,
        items: eventItems,
      },
    };

    sendEvent(payload);
  }, [
    page,
    dietType,
    kcal,
    searchTerm,
    priceFrom,
    priceTo,
    sort,
    items,
    numberOfMeals,
  ]);

  return null;
};
